import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Input from '@cotyorg/ccx-atoms/Input';
import Button from '@cotyorg/ccx-atoms/Button';
import Icon from '@cotyorg/ccx-atoms/Icon';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      selectedOption:
        props.selectedOption ||
        (props.options && props.options.length > 0
          ? props.options[0].value
          : ''),
      isOpened: false,
    };
  }

  handleSearch(event) {
    this.setState({
      searchTerm: event.target.value.toLowerCase(),
    });
  }

  openDropdown() {
    this.setState({
      isOpened: !this.state.isOpened,
    });
  }

  selectOption({ value }) {
    this.setState({
      selectedOption: value,
      isOpened: false,
      searchTerm: '',
    });
  }

  render() {
    const {
      style,
      hasSearch,
      options,
      chevronUpIconPath,
      chevronDownIconPath,
      onSelect,
      selectedOption: selectedOptionProps,
    } = this.props;

    if (!options || options.length === 0) {
      return null;
    }

    const { isOpened, searchTerm, selectedOption } = this.state;

    const dropdownCssClass = classNames('dropdown', {
      'dropdown--open': isOpened,
      [`card--${style}`]: style,
    });
    const dropdownMenuCssClass = classNames('dropdown__menu', {});

    const filterList = options.filter(option =>
      option.value.toLowerCase().includes(searchTerm));

    const getIconName = isOpened ? chevronUpIconPath : chevronDownIconPath;

    const actualOption = options.find(option => option.value === selectedOptionProps);

    return (
      <div
        className={dropdownCssClass}
        ref={(dropdown) => {
          this.dropdown = dropdown;
        }}
      >
        <Button
          extraClass="dropdown__button"
          theme="primary"
          onClick={event => this.openDropdown(event)}
        >
          <span className="dropdown__label">{selectedOption}</span>

          <Icon extraClass="dropdown__icon" iconSrc={getIconName} />

          {actualOption && actualOption.additionalText && (
            <span className="dropdown__button-additional-text">
              {actualOption.additionalText}
            </span>
          )}
        </Button>

        {isOpened && (
          <div className={dropdownMenuCssClass}>
            {hasSearch && (
              <Input
                type="text"
                placeholder="Search..."
                extraClass="dropdown__search"
                onChange={event => this.handleSearch(event)}
              />
            )}

            {filterList.length ? (
              <ul className="dropdown__list">
                {filterList.map(({ key, value, additionalText }) => (
                  /* eslint-disable jsx-a11y/click-events-have-key-events,
                  jsx-a11y/no-noninteractive-element-interactions */
                  <li
                    className="dropdown__list-item"
                    key={key}
                    onClick={(event) => {
                      this.selectOption({ value });

                      if (onSelect) {
                        onSelect({ event, option: { key, value } });
                      }
                    }}
                  >
                    {value}

                    {additionalText && (
                      <span className="dropdown__list-additional-text">
                        {additionalText}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              /* eslint-enable jsx-a11y/click-events-have-key-events,
                  jsx-a11y/no-noninteractive-element-interactions */
              <p>No results...</p>
            )}
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  style: PropTypes.string,
  hasSearch: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })),
  chevronUpIconPath: PropTypes.string,
  chevronDownIconPath: PropTypes.string,
  onSelect: PropTypes.func,
  selectedOption: PropTypes.string,
};

export default Dropdown;
